import { render } from "./QuickAddItem.vue?vue&type=template&id=637d2a93&scoped=true"
import script from "./QuickAddItem.vue?vue&type=script&lang=js"
export * from "./QuickAddItem.vue?vue&type=script&lang=js"

import "./QuickAddItem.vue?vue&type=style&index=0&id=637d2a93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637d2a93"]])

export default __exports__